<template>
  <v-form @submit.native.prevent="submit">
    <v-row no-gutters justify="center" align="center" class="pb-5">
      <h3>Mot de passe oublié ?</h3>
    </v-row>
    <template v-if="!hasTriedToInit || isServerError">
      <v-alert type="error" text class="mb-5" v-if="isServerError">Informations incorrectes</v-alert>
      <v-row no-gutters justify="center" align="center">
        <v-text-field
          v-model="username"
          :error="isUsernameError"
          :disabled="isSubmitting"
          dark
          outlined
          flat
          autofocus
          placeholder="Identifiant"
          prepend-inner-icon="person"
        />
      </v-row>
      <v-btn
        type="submit"
        dark
        large
        block
        depressed
        :loading="isSubmitting"
        class="n-secondary-btn"
      >
        Réinitialiser le mot de passe
      </v-btn>
    </template>
    <template v-else>
      <v-alert type="success" text color="white" class="mb-5">Un e-mail vient de vous être envoyé</v-alert>
    </template>
    <v-row no-gutters justify="center" align="center">
      <v-btn
        text
        :disabled="isSubmitting"
        color="grey lighten-1"
        class="n-btn mt-3"
        :to="{ name: `login` }"
      >
        <v-icon class="mr-1">chevron_left</v-icon>
        Retour à la connexion
      </v-btn>
    </v-row>
  </v-form>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  name: `ForgotPassword`,

  data: () => ({
    isUsernameError: false,
    isServerError: false,
    isSubmitting: false,
    hasTriedToInit: false,
  }),

  computed: {
    username: {
      get() { return this.$store.state[`ui/login`].username; },
      set(value) { this.$store.commit(`ui/login/SET_USERNAME`, value); },
    },
    isPasswordInit: {
      get() { return this.$store.state[`ui/login`].isPasswordInit; },
      set(value) { this.$store.commit(`ui/login/SET_IS_PASSWORD_INIT`, value); },
    },
    ...mapState(`model/auth`, [`accessToken`]),
  },

  methods: {
    async submit() {
      this.isUsernameError = false;
      this.isServerError = false;
      this.hasTriedToInit = false;

      if (_.trim(this.username) === ``) { this.isUsernameError = true; }

      if (this.isUsernameError) { return; }

      this.isSubmitting = true;
      await this.$store.dispatch(`ui/login/initPassword`);
      this.isSubmitting = false;
      this.hasTriedToInit = true;

      if (!this.isPasswordInit) {
        this.isServerError = true;
      }
    },
  },

  beforeMount() {
    this.isPasswordInit = false;
  },
};
</script>

<style lang="scss">
</style>
